module.exports = __webpack_public_path__ + "static/media/RESTAURANT-INFO-RESALE-CERT.bca259f5.pdf";